import type { V2EnergyResilienceConfigBatchDeletePostRequest } from '@maxtropy/device-customer-apis-v2';

export type ConfigMediumType = MediumType;
export type ConfigDimension = NonNullable<V2EnergyResilienceConfigBatchDeletePostRequest['dimension']>;

export enum MediumType {
  Electricity = 0,
  NaturalGas = 1,
  CompressedAir = 2,
  CarbonDioxide = 3,
  Oxygen = 4,
  Argon = 5,
}

export enum ScopeKey {
  Factory = 'factory',
  Station = 'station',
  Area = 'area',
  Outlet = 'outlet',
  Compressor = 'compressor',
}

export enum DimensionKey {
  Line = 'line',
  Station = 'station',
  Plant = 'plant',
  Outlet = 'outlet',
  Area = 'area',
  Compressor = 'compressor',
}

export interface SelectOption {
  label: string;
  value: string | number;
  [key: string]: unknown;
}

export type RecordMap = Record<string, Record<string, unknown>[] | string[] | number[] | number | string | undefined>;

export interface ResilienceRecord extends RecordMap {
  id: number;
  energy: MediumType;
  scope: ScopeKey;
}

export interface FieldConfig {
  name: string;
  label: string;
  dataIndex?: string;
  unit?: string;
}

export interface ScopeConfig {
  label: string;
  fields: FieldConfig[];
}
